import colorPallete, { bodyFonts, elevation, headlineFonts } from "@DSG/MobiusOverrides/styles/variables";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { useContext } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

export interface BrandCarouselStyles {
    eventsCarouselContainer?: InjectableCss;
    titleText?: TypographyPresentationProps;
    carouselSlidesContainer?: InjectableCss;
    carouselSlidesContainerTwo?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState) => ({});

const enum fields {
    titleAlignment = "titleAlignment",
    localEventsTitle = "localEventsTitle",
    lookAtBranchTitle = "lookAtBranchTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.titleAlignment]: string;
        [fields.localEventsTitle]: string;
        [fields.lookAtBranchTitle]: string;
    };
}

type Props = OwnProps;

export const brandCarouselStyles: BrandCarouselStyles = {
    eventsCarouselContainer: {
        css: css``,
    },
    titleText: {
        variant: "h2",
        weight: headlineFonts.headline2SemiBoldLg.fontWeight,
        css: css`
            text-align: center;
            font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
            line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
            margin-bottom: 0;
            @media only screen and (max-width: 768px) {
                font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                padding: 0 16px;
            }
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            column-gap: 40px;
            justify-content: center;
            padding: 24px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            column-gap: 24px;
                            flex-direction: column;
                            align-items: center;
                            row-gap: 24px;
                            padding-bottom: 40px;
                            margin-bottom: 40px;
                            border-bottom: 1px solid ${colorPallete.grey300};
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}

            img {
                height: auto;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            > a {
                                margin-left: 20px;
                                margin-right: 20px;
                            }
                        `,
                    ],
                    "min",
                )}

            .events-carousel-container {
                display: flex;
                column-gap: 40px;
                padding: 24px;
            }

            .events-slide-wrapper {
                max-width: 256px;
                padding: 16px;

                [class*="LazyImageStyle-"] {
                    height: auto;
                }

                img {
                    display: block;
                    border-radius: 8px;
                    margin-bottom: 24px;
                    min-width: 224px;
                    max-width: 224px;
                    min-height: 183px;
                    max-height: 183px;
                    object-fit: cover;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                border: 1px solid ${colorPallete.grey300};
                                border-radius: 8px;
                                box-shadow: ${elevation.dp04};

                                img {
                                    min-width: 210px;
                                    max-width: 100%;
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .event-title {
                display: inline-block;
                font-size: 16px;
                font-weight: 600;
                line-height: 20.8px;
                color: ${colorPallete.primaryRed500};
                margin-bottom: 8px;

                span {
                    color: ${colorPallete.primaryRed500};
                }
            }

            p {
                font-size: ${bodyFonts.body2RegularLg.fontSize};
                line-height: ${bodyFonts.body2RegularLg.lineHeight};
                margin-bottom: 0;
            }
        `,
    },
    carouselSlidesContainerTwo: {
        css: css`
            padding: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 24px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            .branch-details-carousel {
                padding: 16px;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    display: block;
                    margin-bottom: 16px;
                    min-width: 520px;
                    max-width: 520px;
                    max-height: 283px;
                    min-height: 283px;
                    border-radius: 8px;
                    object-fit: cover;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                border: 1px solid ${colorPallete.grey300};
                                border-radius: 8px;
                                box-shadow: ${elevation.dp04};
                                margin: 5px;

                                img {
                                    min-width: 310px;
                                    max-width: 100%;
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .branch-description {
                font-size: ${bodyFonts.body2RegularLg.fontSize};
                line-height: ${bodyFonts.body2RegularLg.lineHeight};
                text-align: center;
                margin-bottom: 0;
            }
        `,
    },
};

export const ContentWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`;

const DsgBranchEventsDisplay = ({ fields }: Props) => {
    const { value: dealer } = useContext(DealerStateContext);
    if (!dealer) {
        return null;
    }

    const event1 = () => {
        const receivedDate = new Date(dealer?.properties["branchEventEditorDate1"]);
        const currentDate = new Date();
        return receivedDate >= currentDate;
    };
    const event2 = () => {
        const receivedDate = new Date(dealer?.properties["branchEventEditorDate2"]);
        const currentDate = new Date();
        return receivedDate >= currentDate;
    };
    const isEvent1Valid = event1();
    const isEvent2Valid = event2();

    const styles = brandCarouselStyles;
    const localEventsTitle = fields.localEventsTitle ? fields.localEventsTitle : "";
    const lookAtBranchTitle = fields.lookAtBranchTitle
        ? fields.lookAtBranchTitle?.replace("'BranchName'", dealer.name)
        : "";

    let oneClassName = "";

    if ((isEvent1Valid || isEvent2Valid) && dealer?.properties["lookAtEventEditor"]?.trim().length <= 0) {
        oneClassName = "one-item-present";
    } else if (dealer?.properties["lookAtEventEditor"]?.trim().length > 0 && (!isEvent1Valid || !isEvent2Valid)) {
        oneClassName = "one-item-present";
    } else {
        oneClassName = "";
    }

    if ((isEvent1Valid && !isEvent2Valid) || (!isEvent1Valid && isEvent2Valid)) {
        oneClassName = "one-item-present"
    }

    return (
        <StyledWrapper className={`branch-location-sliders ${oneClassName}`}>
            {((dealer?.properties["branchEventEditor1"]?.trim().length > 0 && isEvent1Valid) ||
                (dealer?.properties["branchEventEditor2"]?.trim().length > 0 && isEvent2Valid)) && (
                <StyledWrapper className="events-carousel-container" {...styles.eventsCarouselContainer}>
                    {localEventsTitle && (isEvent1Valid || isEvent2Valid) && (
                        <ContentWrapper className="wrapper">
                            <Typography {...styles.titleText}>{localEventsTitle}</Typography>
                        </ContentWrapper>
                    )}
                    <StyledWrapper {...styles.carouselSlidesContainer} className="carouselSliderContainer">
                        {isEvent1Valid && (
                            <StyledWrapper className="events-slide-wrapper">
                                {parse(dealer?.properties["branchEventEditor1"], parserOptions)}
                            </StyledWrapper>
                        )}
                        {isEvent2Valid && (
                            <StyledWrapper className="events-slide-wrapper">
                                {parse(dealer?.properties["branchEventEditor2"], parserOptions)}
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            )}
            {dealer?.properties["lookAtEventEditor"]?.trim().length > 0 && (
                <>
                    <StyledWrapper>
                        {lookAtBranchTitle && (
                            <ContentWrapper className="wrapper">
                                <Typography {...styles.titleText}>{lookAtBranchTitle}</Typography>
                            </ContentWrapper>
                        )}
                        <StyledWrapper
                            {...styles.carouselSlidesContainerTwo}
                            data-test-selector="branchImageCarousel_content"
                        >
                            <div className="branch-details-carousel">
                                {parse(dealer?.properties["lookAtEventEditor"], parserOptions)}
                            </div>
                        </StyledWrapper>
                    </StyledWrapper>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(DsgBranchEventsDisplay),
    definition: {
        group: "Common",
        icon: "gallery-thumbnails",
        fieldDefinitions: [
            {
                name: fields.localEventsTitle,
                displayName: "Local Events Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 0,
            },
            {
                name: fields.lookAtBranchTitle,
                displayName: "Look At Branch Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 1,
            },
            {
                name: fields.titleAlignment,
                displayName: "Title Alignment",
                editorTemplate: "RadioButtonsField",
                defaultValue: "center",
                horizontal: true,
                fieldType: "General",
                sortOrder: 2,

                options: [
                    {
                        displayName: "Left",
                        value: "flex-start",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    {
                        displayName: "Right",
                        value: "flex-end",
                    },
                ],
            },
        ],
    },
};
export default widgetModule;
